import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";

const Screen = lazy(() => import("../../views/answer/PreviewAccessDenied"));

export const Route = createFileRoute("/(open)/preview-access-denied")({
  component: RouteComponent,
  staticData: {
    routeKey: "previewAccessDenied",
    access: "open",
    layout: "blank",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
